export const STAGE_COLORS = {
    DESIGN: '#B3EBF2',
    PROCUREMENT: '#FFFFC5',
    MANUFACTURING_PLANNING: '#F7D9BC',
    MANUFACTURING: '#C8B6FF',
    MANUFACTURING_EXECUTION: '#c0c9ee',
    TESTING: '#cedf9f',
    HANDOVER_TO_DISPATCH: '#D1E8D1',
    DISPATCH: '#FFD580',
    COMMERCIAL_CLEARANCE: '#B8D8F3',
    COMPLETED: '#A2cb8b',
    VALIDATION: '#ccc',
    VALIDATION_COMPLETED: '#C8E6C9',
    DEFAULT: '#616161',
};
